// Browser-side trace logger for the landing chat. On by default; turn off
// from the devtools console with:
//   localStorage.setItem('shroud:chat-debug', '0'); location.reload()
// Turn back on with the same key set to anything else (or remove it).

const ENABLED: boolean = (() => {
  try {
    const v = localStorage.getItem('shroud:chat-debug');
    return v !== '0' && v !== 'false';
  } catch {
    return true;
  }
})();

const TAG_STYLE = 'color:#a855f7;font-weight:bold';
const RESET_STYLE = 'color:inherit;font-weight:normal';

export function dbg(label: string, ...args: unknown[]): void {
  if (!ENABLED) return;
  console.log(`%c[chat]%c ${label}`, TAG_STYLE, RESET_STYLE, ...args);
}

export function dbgErr(label: string, ...args: unknown[]): void {
  if (!ENABLED) return;
  console.warn(`%c[chat]%c ${label}`, TAG_STYLE, RESET_STYLE, ...args);
}

export function preview(s: string, max: number = 200): string {
  if (s.length <= max) return s;
  return s.slice(0, max) + `…(+${s.length - max} chars)`;
}
